import * as React from 'react'
import { Richtext } from 'storyblok-js-client'
import { NODE_LI, NODE_UL } from 'storyblok-rich-text-react-renderer'
import { CheckListItem, StyledCheckList } from '../../components/UI/CheckListItem'
import { renderRichtext } from './renderRichtext'

export const renderRichtextChecklist = (content: Richtext) => {
  return renderRichtext(content, {
    nodeResolvers: {
      [NODE_UL]: children => {
        return <StyledCheckList>{children}</StyledCheckList>
      },
      [NODE_LI]: children => {
        return <CheckListItem>{children}</CheckListItem>
      },
    },
  })
}
